/**
 * Implements a simple logger that logs to console
 *
 * @type {{logError: module.exports.logError, logWarning: module.exports.logWarning, logInfo: module.exports.logInfo, logObj: module.exports.logObj}}
 */

const noop = () => { };

const bindConsoleFunc = (existingFunc) => {
  if (!console || !console.log || typeof existingFunc !== 'function') { // eslint-disable-line no-console
    return noop;
  }

  return existingFunc.bind(console);
};

module.exports = {
  groupEnd: bindConsoleFunc(console.groupEnd), // eslint-disable-line no-console
  groupStart: bindConsoleFunc(console.groupCollapsed), // eslint-disable-line no-console
  logError: bindConsoleFunc(console.error), // eslint-disable-line no-console
  logInfo: bindConsoleFunc(console.info), // eslint-disable-line no-console
  logObj: bindConsoleFunc(console.dir), // eslint-disable-line no-console
  logWarning: bindConsoleFunc(console.warn), // eslint-disable-line no-console
  noop
};



// WEBPACK FOOTER //
// ./node_modules/@salecycle/log-tiny/index.js